import { rem } from "@certn/cascadia";
import { Icon, Text, useColors } from "@certn/cascadia-react";
import { CascadiaColor, CascadiaMiniIcon } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

export type CheckStatusProps = {
  type: CheckStatusType;
  children: React.ReactNode;
  testId?: string;
  hasGrayBackground?: boolean;
};

export type CheckStatusType =
  | "ready"
  | "progress"
  | "upgrade"
  | "expired"
  | "processing"
  | "complete"
  | "archived"
  | "dispute";

export function CheckStatus(props: CheckStatusProps) {
  const { type, hasGrayBackground, children, testId } = props;
  const colors = useColors();

  return (
    <div
      className={css(wrapperStyles, {
        background: hasGrayBackground
          ? colors["background-accent-neutral-weak"]
          : colors["background-base"],
      })}
    >
      <Icon
        fill
        testID={testId}
        name={statusStyles[type].icon as CascadiaMiniIcon}
        color={statusStyles[type].iconColor as CascadiaColor}
      />
      <Text style="global/label-small">{children}</Text>
    </div>
  );
}

const wrapperStyles = {
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  borderRadius: rem("space-8"),
  gap: rem("space-2"),
  paddingTop: rem("space-1"),
  paddingRight: rem("space-4"),
  paddingBottom: rem("space-1"),
  paddingLeft: rem("space-3"),
};

const statusStyles = {
  ready: {
    iconColor: "icon-success",
    icon: "emoji_flags",
  },
  upgrade: {
    iconColor: "icon-success",
    icon: "emoji_flags",
  },
  progress: {
    iconColor: "icon-info",
    icon: "resume",
  },
  expired: {
    iconColor: "icon-danger",
    icon: "notification_important",
  },
  processing: {
    iconColor: "icon-info",
    icon: "document_scanner",
  },
  complete: {
    iconColor: "icon-success",
    icon: "check_circle",
  },
  archived: {
    iconColor: "text-disabled",
    icon: "inventory_2",
  },
  dispute: {
    iconColor: "icon-warning",
    icon: "hourglass_top",
  },
};
